import { observable, action } from 'mobx'
import YoutubeState from './youtube'

export default class I18nState extends YoutubeState {
  @observable i18n = {}
  @observable lang = 'en'

  __ = str => {
    return this.i18n[str] || str
  }

  @action changeLang (lang) {
    this.lang = lang
    this.i18n = {}
  }
}
